export const defaultTheme = {
  isDark: false,
  colors: {
    white: '#FFFFFF',
    menuBackground: '#FFFFFF',
    grayExtraLight: '#FCFDFE',
    grayBackground: '#F7F8FC',
    grayLightest: '#F0F1F7',
    grayDividerGraph: '#EBEDF0',
    grayDivider: '#DFE0EB',
    grayLight: '#C5C7CD',
    gray: '#9FA2B4',
    grayDark: '#4B506D',
    modalOverlay: '#4B506D3D',
    modalOverlayDarker: '#4B506D99',
    lightBlack: '#525252',
    black: '#252733',
    lightYellow: '#FFF5EB',
    yellow: '#FEA500',
    lightGreen: '#F4FCF7',
    green: '#00AE6E',
    lightBlue: '#E7EAFF',
    blue: '#018EFF',
    blueDark: '#253DD9',
    secondaryBlue: '#E3F2FF',
    saturatedBlue: '#0022FF',
    lightestPurple: '#E0D4F8',
    lightPurple: '#8355E2',
    purple: '#642ADB',
    midDarkPurple: '#9A53CB',
    darkPurple: '#4B20A4',
    accentLightest: '#DDE2FF',
    accentLight: '#2137C3',
    accentHover: '#182161',
    accent: '#253292',
    accentDark: '#182161',
    accentDisabled: '#E7EAFF',
    pink: '#FF4EA1',
    pinkLight: '#FF81BC',
    red: '#FE2142',
    redLight: '#FFF7F7',
    secondaryRed: '#FEF5F6',

    pastelGreen: '#93EDCA',
    pastelYellow: '#F6D061',
    pastelBlue: '#A6DEFF',
    pastelPurple: '#C9B6F2',
    pastelPink: '#F4BDE7',
    pastelRed: '#FFB0B0',
    lilac: '#B26EFF',
    calendarBlack: '#1F1F1F',

    // custom colors
    textAccent: '#253292',
    actionSurface: '#EBEDF0',
    actionSurfaceHover: '#DDE2FF',
    iconDefault: '#9FA2B4',
    iconHover: '#253292',
    staticWhite: '#FFFFFF',
    staticLavender: '#E7EAFF',
    primaryAction: '#253292',
    inactiveText: '#9FA2B4',
    inactiveSurface: '#DFE0EB',
    primaryDisabled: '#E0D4F8',
    secondaryPressedBg: '#182161',
    disabledSurface: '#DDE2FF',
    disabledText: '#FFFFFF',
    filterBg: '#F7F8FC',
    filterText: '#4B506D',
    filterActiveText: '#253292',
    filterDisabledText: '#9FA2B4',
    dropdownDisabledText: '#9FA2B4',
    bannerBackground: '#FFFFFF',
    lavenderLightest: '#F2EFFC',
    sidebarLabel: '#642ADB',
    sidebarHover: '#F0F1F7',
    sidebarSelected: '#F2EFFC',
    sidebarBackground: '#FFFFFF',
    calendarSelectedText: '#4B506D',
    dateBgHover: '#F0F1F7',
    linkText: '#0022FF'
  },
  fonts: {
    Poppins: 'Poppins',
    GloriaHallelujah: 'Gloria Hallelujah'
  },
  borders: {
    smallBorderRadius: '4px',
    bigBorderRadius: '8px'
  },
  breakpoints: {
    xs: '400px',
    sm: '600px',
    md: '900px',
    lg: '1280px',
    xl: '1440px',
    xxl: '1920px',
    xxxl: '2560px'
  }
};
